import React, {useEffect, useState} from 'react';
import {Button, Dialog, Text, TextTypography} from 'wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../Widget/ControllerContext';
import {hasPickupOption} from '../../../domain/utils/bi.util';
import {getErrorPropsFromCode} from '../../../domain/utils/errors';
import {classes} from './ErrorDialog.st.css';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';

export enum ErrorDialogDataHooks {
  Root = 'ErrorDialogDataHooks.Root',
  Title = 'ErrorDialogDataHooks.Title',
  Description = 'ErrorDialogDataHooks.Description',
  Button = 'ErrorDialogDataHooks.Button',
}

export const ErrorDialog = () => {
  const {experiments} = useExperiments();
  const isGiftCardMixedCartEnabled = experiments.enabled(SPECS.GiftCardAddToCartSettings);

  const {
    checkoutStore: {placeOrderError, onErrorDialogOpened, onErrorDialogClosed, checkout, updateCheckoutError},
    navigationStore: {clickOnBackToSite, clickOnReturnToCart},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  const [error] = useState(checkout.errors.noItemsError || placeOrderError || updateCheckoutError);
  const [isDialogOpen, setIsDialogOpen] = useState(true);

  useEffect(() => {
    onErrorDialogOpened();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDialogOnClose = () => {
    onErrorDialogClosed();
    setIsDialogOpen(false);
  };

  const handleClickOnReturnToCart = () => {
    void clickOnReturnToCart();
  };

  const errorToDisplay = getErrorPropsFromCode(
    error,
    localeKeys,
    {
      clickOnBackToSite,
      handleClickOnReturnToCart,
      handleDialogOnClose,
    },
    hasPickupOption(checkout),
    Boolean(checkout.cartId),
    isGiftCardMixedCartEnabled
  );

  return (
    <Dialog data-hook={ErrorDialogDataHooks.Root} isOpen={isDialogOpen} onClose={handleDialogOnClose}>
      <div className={classes.root}>
        <div className={classes.content}>
          <Text data-hook={ErrorDialogDataHooks.Title} typography={TextTypography.largeTitle}>
            {errorToDisplay.title}
          </Text>
          <Text data-hook={ErrorDialogDataHooks.Description} typography={TextTypography.runningText}>
            {errorToDisplay.description}
          </Text>
        </div>
        <Button
          data-hook={ErrorDialogDataHooks.Button}
          className={classes.button}
          onClick={() => errorToDisplay.action.fn()}
          upgrade>
          {errorToDisplay.action.name}
        </Button>
      </div>
    </Dialog>
  );
};
